<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="500px"
        transition="slide-y-transition"
        origin="top center"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Zmiana nakładu do nadania
                </h1>
            </v-card-title>

            <div class="mx-5 my-1">
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-model.number="address.orderAddress.amountToShip"
                            v-mask="'#######'"
                            label="Nakład"
                            outlined
                            :error-messages="amountToShipErrors"
                        />
                    </v-col>
                </v-row>
            </div>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    :disabled="actionLoading"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :loading="actionLoading"
                    @click="updateSending"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { errorHandler } from '@/utils/errorHandler'
import { required, integer, minValue } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'

export default {
    name: 'AmountToShipDialog',
    directives: { mask },
    props: {
        isOpen: {
            type: Boolean
        },
        addressData: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            address: {
                orderAddress: {
                    amountToShip: null,
                }
            },
            actionLoading: false
        }
    },
    validations() {
        return {
            address: {
                orderAddress: {
                    amountToShip: {
                        required,
                        integer,
                        minValue: minValue(1)
                    }
                }
            }
        }
    },
    computed: {
        amountToShipErrors() {
            const errors = []

            if (!this.$v.address.orderAddress.amountToShip.$dirty) return errors

            if (this.$v.address.orderAddress.amountToShip.$invalid) {
                errors.push('Proszę podać prawidłową wartość')
            }

            return errors
        },
        isDataFromPM() { // Dane pobrane ze sklepu
            return this.address.orderAddress.isPmData
        }
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.address = JSON.parse(JSON.stringify(this.addressData))
            }
        }
    },
    methods: {
        updateSending() {
            this.$v.$touch()
            if (this.$v.$invalid) return

            if (!this.isDataFromPM) {
                this.actionLoading = true

                const orderAddress = this.address.orderAddress

                this.$store.dispatch('shipments/sendings/getBoxesInfo', {
                    productLength: orderAddress.productLength,
                    productWidth: orderAddress.productWidth,
                    productHeight: orderAddress.productHeight,
                    productWeight: orderAddress.productWeight,
                    amount: orderAddress.amountToShip,
                    productTypeId: orderAddress.productTypeId
                })
                    .then(response => {
                        this.address.orderAddress.packageAmount = response.data.packageAmount
                        this.address.orderAddress.packageAmountSum = response.data.packageAmount
                        this.address.orderAddress.weight = response.data.weight
                        this.address.orderAddress.boxesInfo = response.data.boxesInfo

                        this.$emit('update-sending', this.address)
                        this.$emit('reset-recalculate-unit-box')
                        this.onClose()
                    })
                    .catch(error => errorHandler(error))
                    .finally(() => {
                        this.actionLoading = false
                    })
            } else {
                this.$emit('update-sending', this.address)
                this.onClose()
            }
        },
        onClose() {
            setTimeout(() => {
                this.$v.$reset()
                this.address = JSON.parse(JSON.stringify(this.addressData))
            }, 500)
            this.$emit('on-close')
        },
    }
}
</script>